import type { PaginatedResponse } from '@/types/pagination.ts'

export enum InteractionOverviewStatusValues {
  REPLIED = 'replied',
  SEEN = 'seen',
  IGNORED = 'ignored',
}

export enum SubscriptionLengthStatusValues {
  EXPIRED = 'expired',
  ACTIVE = 'active',
}

export interface SubscribersStatusType<T> {
  count: number
  status: T
}
export interface SubscribersAnalysisData {
  averageWelcomeMessageResponseTime: number
  interactionOverview: SubscribersStatusType<InteractionOverviewStatusValues>[]
  numberOfFanWhoBoughtPPV: number
  subscriptionLength: SubscribersStatusType<SubscriptionLengthStatusValues>[]
  highSpendingFansCount: number
  lowSpendingFansCount: number
}

export interface SubscribersAnalysisDataUI extends SubscribersAnalysisData {
  interactionOverviewData: {
    [key in InteractionOverviewStatusValues]?: number
  }
  subscriptionLengthData: {
    [key in SubscriptionLengthStatusValues]?: number
  }
  subscriptionLengthSum: number
}

export interface SpendingCustomerListContent {
  displayName: string
  totalRevenue: number
  fanId: number
  username: string
  avatar: string
}

export type SpendingCustomerListResponse =
  PaginatedResponse<SpendingCustomerListContent>

export interface PPVSalesRatioChartType {
  title: string
  value: number
  color: string
  icon: React.ReactElement
  onChange: (value: number) => void
}
